import { $GET, $POST } from '../libs/http';


/**
 * @desc
 * @param {}
 */
export function fetchActivityInfo(params, opts) {
    return $GET('/api/v1/activity/userPrize', params, opts)
}

/**
 * @desc 排行榜
 * @param {*} params
 * @param {*} opts
 */
export function fetchRankingList(params, opts) {
    return $GET('/api/v1/activity/rankinglist', params, opts)
}

/**
 * @desc 活动页信息
 * @param {*} params
 * @param {*} opts
 */
export function fetchImageInfo(pageCode, params, opts) {
    return $GET(`/query/imageInfo/${pageCode}`, params, opts)
}

/**
 * @desc MGM活动信息获取
 * @param {*} params
 * @param {*} opts
 */
export function refreshActivityImageUrl(body, opts) {
    return $POST('/api/v1/refreshActivityImageUrl', body, opts)
}

/**
 * @desc 营销页手机号记录
 * @param {{ mobile: string, scene: string }} body
 * @param {*} opts
 */
export function recordMarketingMobile(body, opts) {
    return $POST('/api/v1/marketing/mobile/records', body, opts)
}



// WEBPACK FOOTER //
// ./src/utils/services/activities.js